import { render, staticRenderFns } from "./RankingsTodaysMatches.vue?vue&type=template&id=63b05db8&scoped=true"
import script from "./RankingsTodaysMatches.vue?vue&type=script&lang=js"
export * from "./RankingsTodaysMatches.vue?vue&type=script&lang=js"
import style0 from "./RankingsTodaysMatches.vue?vue&type=style&index=0&id=63b05db8&prod&lang=scss"
import style1 from "./RankingsTodaysMatches.vue?vue&type=style&index=1&id=63b05db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b05db8",
  null
  
)

export default component.exports